import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const StyledRow = styled(Row)`
`

export const StyledLogo = styled.img`
    width: 100%;
    height: auto;
    max-width: 90%;
` 

export const StyledTitle = styled.h1`
    font-size: 3em;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 5%;
`